export function setSessionFilters(key, filters) {
  localStorage.setItem(key, JSON.stringify(filters));
}

export function getSessionFilters(key) {
  return JSON.parse(localStorage.getItem(key)) || {};
}
